import { Button } from "@/components/ui/button";
import moment from "moment";

export function MachineOthSotDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "Machine OTH SOT") {
    const exportData = dataSave.machines.map((machine) => {
      let totalOTH = 0;
      let totalPRTOnOTH = 0;
      let sotNumber = [];
      let partUsage = [];

      machine.service_order_tickets
        .map((sot) => {
          if (data.month_year) {
            const year = data.month_year.split("-")[0];
            const month = data.month_year.split("-")[1];
            if (
              moment(sot.reported_date).format("YYYY") != year ||
              moment(sot.reported_date).format("MM") != month
            ) {
              return null;
            }
          }
          if (
            sot.service_type_name !== "PREVENTIVE_MAINTENANCE" &&
            sot.service_type_name !== "CORRECTIVE_MAINTENANCE"
          ) {
            totalOTH = totalOTH + 1;
            totalPRTOnOTH =
              totalPRTOnOTH +
              (sot.part_request_ticket?.length
                ? sot.part_request_ticket.length
                : 0);
            sotNumber.push(`${sot.so_ticket_no} - ${sot.reported_date}`);
            partUsage.push(
              sot.part_usages
                .map((pu) => {
                  return `${pu.part_detail.name} - ${
                    pu.type == "repairable" ? 1 : pu.part_quantity
                  }`;
                })
                .join(";"),
            );
          }
        })
        .filter((sot) => sot != null);

      return {
        "WS ID": machine.alias,
        "Machine Loc": machine.location_name,
        "Customer Name": machine.customer.name,
        "SE Name": machine.mapping_area?.service_engineer?.user.name,
        "Total of OTH SOT": totalOTH,
        "Total of OTH PRT": totalPRTOnOTH,
        "List of SOT Number": sotNumber.join(";"),
        "List of Part Usage": partUsage.join(";"),
      };
    });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `machine_oth_sot_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
